import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import MapIcon from '@mui/icons-material/Map';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import './../Lease Module/CustomBottomNav.css';
import GuestLoginModal from '../../GuestLoginModal';
import { AuthContext } from '../../AuthContext/AuthContext';

const BASE_NAV_ITEMS = [
  { key: 'home',  icon: <HomeIcon />,               route: '/dashboard',      label: 'Home' },
  { key: 'list',  icon: <FormatListBulletedIcon />, route: '/AuctionList',    label: 'List' },
  { key: 'saves', icon: <FavoriteBorderIcon />,     route: '/auction-saves',  label: 'Saves' },
  { key: 'inbox', icon: <MailOutlineIcon />,        route: '/auction-inbox',  label: 'Inbox' },
];

const MAP_ITEM = {
  key: 'map',
  icon: <MapIcon />,
  route: '/postbank-card',
  label: 'Map',
};

const AuctionBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentKey, setCurrentKey] = useState('');
  const navRef = useRef(null);
  const { isGuest } = useContext(AuthContext);
  const [showGuestModal, setShowGuestModal] = useState(false);

  const guestRestrictedTabs = ['saves', 'inbox'];

  // ✅ Case-insensitive path matching
  const pathLower = location.pathname.toLowerCase();

  // ✅ Match both /AuctionList and /auction-list, plus detail pages
  const isListPage =
    pathLower.startsWith('/auctionlist') ||
    pathLower.startsWith('/auction-list');

  const isDetailsPage =
    pathLower.startsWith('/auction-property-detail') ||
    pathLower.startsWith('/post_bankcard_indetail');

  const navItems = (isListPage || isDetailsPage)
    ? BASE_NAV_ITEMS.map(item => (item.key === 'list' ? MAP_ITEM : item))
    : BASE_NAV_ITEMS;

  // ── Determine active key ────────────────────────────────────────────────
  useEffect(() => {
    // Map page — highlight Map
    if (pathLower.startsWith('/postbank-card') || pathLower.startsWith('/auction-map')) {
      setCurrentKey('map');
      return;
    }

    const activeItem =
      navItems.find(item => pathLower.startsWith(item.route.toLowerCase()))?.key ||
      'home';
    setCurrentKey(activeItem);
  }, [location.pathname, navItems, pathLower]);

  const handleNav = (item) => {
    if (isGuest && guestRestrictedTabs.includes(item.key)) {
      setShowGuestModal(true);
      return;
    }
    setCurrentKey(item.key);
    navigate(item.route);
  };

  // ── Move indicator ──────────────────────────────────────────────────────
  useEffect(() => {
    const current = navRef.current?.querySelector(
      `.nav-item[data-key="${currentKey}"]`
    );
    const indicator = navRef.current?.querySelector('.nav-indicator');
    if (current && indicator) {
      const { offsetLeft, offsetWidth } = current;
      indicator.style.left = `${offsetLeft + offsetWidth / 2 - 25}px`;
    }
  }, [currentKey, navItems]);

  return (
    <div className="nav-wrapper">
      <div className="nav-bar" ref={navRef}>
        {navItems.map((item) => (
          <div
            key={item.key}
            data-key={item.key}
            className={`nav-item ${currentKey === item.key ? 'nav-item-active' : ''}`}
            onClick={() => handleNav(item)}
          >
            {item.icon}
            <div className="nav-label">{item.label}</div>
          </div>
        ))}
        <div className="nav-indicator" />
      </div>

      <GuestLoginModal
        open={showGuestModal}
        onClose={() => setShowGuestModal(false)}
      />
    </div>
  );
};

export default AuctionBottomNav;